
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import VoucherService from '@/services/voucher.service';
import VehicleService from '@/services/vehicle.service';
import VehicleModal from '@/components/carModule/VehicleModal.vue';
import { CarFieldFactory } from '@/models/carFieldFactory';
import { EVehicleOperations } from '@/common/enum/carSpu';
import previewModal from '@/components/richText/previewModal.vue';

enum EnumBizRange {
  LAUNCH = '上线',
  OFFLINE = '下线',
}

@Component({
  components: {
    VehicleModal,
    previewModal,
  },
})
export default class vehicleList extends Vue {
  @lazyInject(VoucherService)
  private voucherService!: VoucherService;

  @lazyInject(VehicleService)
  private vehicleService!: VehicleService;

  @Ref('vehicleModal') vehicleModal!: VehicleModal;

  @Ref('previewModal') previewModal!: previewModal;

  @Prop()
  shopId!: string;

  EnumBizRange = EnumBizRange;

  size = 'small';

  selectedCategoryId = -1;

  categoryList = [];

  columns = [
    {
      dataIndex: 'commodity_code',
      title: '商品编码',
      key: 'commodity_code',
      align: 'center',
      width: 150,
    },
    {
      title: '车辆图片',
      dataIndex: 'image',
      key: 'image',
      align: 'center',
      scopedSlots: { customRender: 'image' },
    },
    {
      title: '名称',
      key: 'name',
      dataIndex: 'name',
      align: 'center',
      width: 100,
    },
    {
      title: '所属分类',
      key: 'category',
      dataIndex: 'category',
      align: 'center',
      width: 100,
    },
    {
      title: '市场价',
      key: 'market_price',
      dataIndex: 'market_price',
      align: 'center',
      width: 140,
    },
    {
      title: '销售价',
      key: 'price',
      dataIndex: 'price',
      align: 'center',
      width: 140,
    },
    {
      title: '创建时间',
      key: 'created_at',
      dataIndex: 'created_at',
      align: 'center',
      width: 120,
    },
    {
      title: '最近修改时间',
      key: 'updated_at',
      dataIndex: 'updated_at',
      align: 'center',
      width: 120,
    },
    {
      title: '状态',
      key: 'online',
      dataIndex: 'online',
      align: 'center',
      width: 120,
    },

    {
      title: '操作',
      key: 'action',
      align: 'center',
      fixed: 'right',
      width: 180,
      scopedSlots: { customRender: 'action' },
    },
  ];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  async init() {
    const category = await this.vehicleService.getCommodityCategory({
      shop_id: this.shopId,
    });
    console.log(category);
    this.categoryList = category;
    this.commodityList();
  }

  catrgorySelect(id: number) {
    console.log(id);
    this.selectedCategoryId = id;
    this.commodityList();
  }

  async commodityList() {
    const res = await this.vehicleService.getCommodityList({
      shop_id: this.shopId,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
      cid: this.selectedCategoryId === -1 ? undefined : this.selectedCategoryId,
    });
    console.log(res);
    this.dataSource = res.list;
    this.pagination.total = res.total;
  }

  async funEdit(item: any) {
    const carFields = CarFieldFactory.init({
      spuType: 'vehicleOperations',
    });
    const res = await this.vehicleService.getCommodityDetail({
      code: item,
    });
    res.tags = res.tags.map((spu: any) => spu.id);
    this.vehicleModal.setup(carFields, res);
    // this.vehicleModal.show(item);
  }

  async funPreview(item: any) {
    const res = await this.vehicleService.getCommodityDetail({
      code: item,
    });
    this.previewModal.init(res);
  }

  funDelete(item: any) {
    const text = '你确定要删除该商品吗？';
    this.$confirm({
      title: '提示',
      content: text,
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const res = await this.vehicleService.deleteCommodity({ code: item });
        if (res) {
          this.$message.success('操作成功');
          this.commodityList();
        }
      },
      onCancel() {},
    });
  }

  funPush(item: any) {
    const text = `你确定要${
      item.online === EnumBizRange.LAUNCH ? '下线' : '上线'
    }该商品吗？`;
    this.$confirm({
      title: '提示',
      content: text,
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const data = {
          code: item.commodity_code,
          type: item.online === EnumBizRange.LAUNCH ? 'offline' : 'online',
        };
        const res = await this.vehicleService.pushCommodity(data);
        if (res) {
          this.$message.success('操作成功');
          this.commodityList();
        }
      },
      onCancel() {},
    });
  }

  handleUpdate(value: any, type: boolean) {
    // this.init();
    if (type) {
      value.tags = [];
    }
    const carFields = CarFieldFactory.init({
      spuType: 'vehicleOperations',
    });
    const isTagsIndex = carFields.findIndex(
      (item) => item.label === EVehicleOperations.TAGS,
    );
    if (value.tagslist && value.tagslist.length > 0) {
      carFields[isTagsIndex].isHidden = false;
    } else {
      carFields[isTagsIndex].isHidden = true;
    }
    this.vehicleModal.setup(carFields, value);
  }

  async handleSubmit(value: any) {
    const {
      shop_id,
      cid,
      images,
      name,
      market_price,
      price,
      tags,
      description,
      commodity_code,
    } = value;
    const params = {
      shop_id,
      commodity_code,
      cid,
      images: images.map((item: any) => item.id),
      name,
      market_price,
      price,
      tags,
      v_rank: 1,
      description,
    };
    console.log(params);
    const res = await this.vehicleService.editCommodity(params);
    if (res) {
      this.$message.success('编辑成功');
      this.vehicleModal.onClose();
      this.commodityList();
    }
  }

  onChangePage(page: number) {
    this.pagination.current = page;
    this.commodityList();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.commodityList();
  }

  dataSource = [];
}
